import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { contributionOrQueue } from "../lib/contribution-client";
import { isAppsInTossChannel } from "../lib/channel";
export function VenueRequest() {
	const [name, setName] = useState(""),
		[message, setMessage] = useState("");
	async function send() {
		try {
			const result = await contributionOrQueue("/api/venue-requests", { name });
			const prior = JSON.parse(
				localStorage.getItem("anjabom.requested-venues.v1") ?? "[]",
			) as string[];
			localStorage.setItem(
				"anjabom.requested-venues.v1",
				JSON.stringify([...new Set([...prior, name])]),
			);
			setMessage(
				result.queued
					? "요청을 기기에 보관했어요. 연결되면 전송해요. 아직 공개 요청 수에는 반영하지 않았어요."
					: "요청을 받았어요. 추가되면 이 기기 소식함에서 확인할 수 있어요.",
			);
		} catch (e) {
			setMessage(
				e instanceof Error ? e.message : "연결을 확인하고 다시 시도해 주세요.",
			);
		}
	}
	if (isAppsInTossChannel()) return null;
	return (
		<section className="stack">
			<h2>찾는 공연장이 없나요?</h2>
			<label className="field">
				공연장 이름
				<input
					className="input"
					minLength={2}
					maxLength={40}
					value={name}
					onChange={(e) => setName(e.target.value)}
				/>
			</label>
			<button
				className="button"
				disabled={name.trim().length < 2}
				onClick={() => void send()}
			>
				공연장 추가 요청하기
			</button>
			<p role="status">{message}</p>
		</section>
	);
}
export function ContributionCoverage() {
	const [data, setData] = useState<{
			seats: Array<{ seat_key: string; count: number }>;
			venues: Array<{ display_name: string; count: number }>;
			rowsWithTips: number | null;
		} | null>(null),
		[error, setError] = useState(""),
		[retry, setRetry] = useState(0);
	useEffect(() => {
		let live = true;
		fetch("/api/contribution-coverage")
			.then(async (r) => {
				if (!r.ok) throw new Error();
				if (live) setData(await r.json());
			})
			.catch(() => {
				if (live) setError("요청 현황을 확인하지 못했어요.");
			});
		return () => {
			live = false;
		};
	}, [retry]);
	return (
		<section className="stack">
			<h2>앉아본 기록 현황</h2>
			{error ? (
				<p role="alert">
					{error}
					<button
						type="button"
						onClick={() => {
							setError("");
							setRetry(retry + 1);
						}}
					>
						다시 불러오기
					</button>
				</p>
			) : data ? (
				<>
					<p>
						{data.rowsWithTips === null
							? "앉아본 기록이 있는 열 수는 아직 확인하지 못했어요."
							: data.rowsWithTips === 0
								? "아직 한 줄이 모인 열이 없어요. 다녀온 자리부터 남겨 주세요."
								: `앉아본 기록이 있는 열 ${data.rowsWithTips}개`}
					</p>
					<h3>가장 많이 찾는 자리</h3>
					{data.seats.length ? (
						<ol>
							{data.seats.map((s) => (
								<li key={s.seat_key}>
									<Link to={`/seat/${encodeURIComponent(s.seat_key)}`}>
										{s.seat_key.split(":").slice(2).join(" · ")} · {s.count}명이
										궁금해해요
									</Link>
								</li>
							))}
						</ol>
					) : (
						<p>아직 요청이 없어요. 궁금한 자리에서 궁금해요를 눌러 주세요.</p>
					)}
					<h3>추가 요청 많은 곳</h3>
					{data.venues.length ? (
						<ol>
							{data.venues.map((v) => (
								<li key={v.display_name}>
									{v.display_name} · 요청 {v.count}건
								</li>
							))}
						</ol>
					) : (
						<p>아직 요청한 공연장이 없어요.</p>
					)}
				</>
			) : (
				<p role="status">요청을 불러오고 있어요.</p>
			)}
			<VenueRequest />
		</section>
	);
}
